// src/data/constants.js

/**
 * Default prize data configuration
 * Used as fallback when no prize configuration is provided in Excel data
 * All values in AUD
 */
export const DEFAULT_PRIZE_DATA = {
  mode: 'whatIf', // Default to What If mode (other options: 'real', 'braggingRights')
  totalPool: 500,
  firstPrize: 200,
  secondPrize: 100,
  thirdPrize: 50,
  rankJumpPrize: 50,
  monthlyPrize: 10, // per month, 10 months in FPL season
  // Default fallback values
  rankJumperGW19Rank: 12,
  rankJumperFinalRank: 5,
  // Default distribution percentages (for What If mode)
  distribution: {
    first: 0.40,   // 40% to first place
    second: 0.20,  // 20% to second place
    third: 0.10,   // 10% to third place
    rankJumper: 0.10, // 10% to rank jumper
    monthly: 0.20   // 20% to monthly winners (distributed)
  }
};
